import { TransformerLayer } from "./TransformerLayer";

export class DynLayer extends TransformerLayer {
   


}
